/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { connect, useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { app, db, signUpWithFacebook, signUpWithGoogle } from "../../firebase";
import { getDocs, getDoc, setDoc, addDoc, collection, query, where, onSnapshot, doc, orderBy, limit } from "firebase/firestore";
import {useHistory} from 'react-router-dom'
import { useEffect, useState, useRef } from "react";
import {set, useForm} from 'react-hook-form';
import Select from 'react-select';
import {customDropdown} from "util/reactCustomStyles";
import useCustomPmrPrograms from "util/useCustomPmrPrograms";
import { signupUser,signupUserReset } from "redux/UserAuthentication/RegisterActions";
import { validateGroupCode, validateGroupCodeReset } from "redux/GroupOrders/GroupOrdersActions";
import Swal from 'sweetalert2'
import { loginUser } from "redux/UserAuthentication/LoginActions";
import googleIcon from 'assets/img/icons/common/google.svg';
import facebookIcon from 'assets/img/icons/common/facebook.svg';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import RegistrationPaymentStep from 'components/Payments/RegistrationPaymentStep';
import IndividualCodeRegistrationPayment from 'components/GroupOrders/IndividualCodeRegistrationPayment';
import { getSpecialty, SPECIALTIES, SPECIALTY_IDS } from 'config/specialtyConfig';
import { switchSpecialty } from 'redux/Specialty/SpecialtyAction';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const Register = (props) => {
  const activeSpecialty = useSelector(state => state.specialty?.activeSpecialty || 'pmr');
  const specialtyName = getSpecialty(activeSpecialty).name;
  const history = useHistory();
  const dispatch = useDispatch();
  const allPmrProgramOptions = useCustomPmrPrograms();
  const [confirmPasswordMatch, setConfirmPasswordMatch] = useState(false);
  const [specialtyDropdownOpen, setSpecialtyDropdownOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [step1Errors, setStep1Errors] = useState({});
  const { register, getValues, unregister,watch, handleSubmit,setValue, formState: { errors } } = useForm();

  const messageRequired = "This field is required.";

  const [university, setUniversity] = useState('');
  const [universities, setUniversities] = useState([])
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [heardAboutUs, setHeardAboutUs] = useState(null);
  const [heardAboutUsOther, setHeardAboutUsOther] = useState('');
  const [stripeData, setStripeData] = useState(null);
  const [isBundleMode, setIsBundleMode] = useState(false);
  const stripeDataRef = useRef(null);
  const groupCodeTimerRef = useRef(null);

  // Real-time group code validation (debounced)
  const handleGroupCodeChange = (e) => {
    const val = e.target.value.toUpperCase();
    setGroupCode(val);
    dispatch(validateGroupCodeReset());

    if (groupCodeTimerRef.current) clearTimeout(groupCodeTimerRef.current);

    if (val.trim().length >= 6) {
      groupCodeTimerRef.current = setTimeout(() => {
        dispatch(validateGroupCode(val.trim()));
      }, 500);
    }
  };

  // Phone number validation and formatting helpers
  const isValidUSE164 = (s) => /^\+1[2-9]\d{2}[2-9]\d{6}$/.test(s);

  const isValidUSNumber = (input) => {
    const d = (input || "").replace(/\D/g, "");
    const e164 =
      d.length === 10 ? `+1${d}` :
        (d.length === 11 && d.startsWith("1") ? `+${d}` : null);
    return e164 ? isValidUSE164(e164) : false;
  };

  const formatUSDisplay = (v = "") => {
    let d = v.replace(/\D/g, "");
    if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
    if (d.length === 0) return "";
    if (d.length < 4) return d;
    if (d.length < 7) return `(${d.slice(0,3)}) ${d.slice(3)}`;
    return `(${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6,10)}`;
  };

  const toE164 = (formatted) => {
    const digits = formatted.replace(/\D/g, "");
    return digits.length === 10 ? `+1${digits}` : null;
  };

  const handlePhoneNumberChange = (e) => {
    const formatted = formatUSDisplay(e.target.value);
    setPhoneNumber(formatted);
    setValue("inputPhoneNumber", formatted);
  };

  const yearOptions = [
    { value: 'Fellow', label: 'Fellow' },
    { value: 'PGY 1', label: 'PGY 1' },
    { value: 'PGY 2', label: 'PGY 2' },
    { value: 'PGY 3', label: 'PGY 3' },
    { value: 'PGY 4', label: 'PGY 4' }
  ];

  const heardAboutUsOptions = [
    { value: 'Residency Program', label: 'Residency Program' },
    { value: 'Co-Resident', label: 'Co-Resident' },
    { value: 'Attending Physician', label: 'Attending Physician' },
    { value: 'Social Media', label: 'Social Media' },
    { value: 'Google Search', label: 'Google Search' },
    { value: 'Conference/Event', label: 'Conference/Event' },
    { value: 'Email', label: 'Email' },
    { value: 'Other', label: 'Other' }
  ];

 const [schools, setschool] = useState([])
   useEffect(() => {
        fetchSchool();
        return () => {
            setschool([]); 
            };
    }, []);

    const fetchSchool = async () => {
        const userCollection = collection(db, "universitiesList");
        const querySnapshot = await getDocs(userCollection);
        querySnapshot.forEach((doc) => {
            let sdoc = doc.data()
            sdoc.universities.unshift("Others")
            setschool(sdoc)
        });
    } 
   

  useEffect(() => {

    register("inputUsername", { required: messageRequired
     });
    // register("inputFullname", { required: messageRequired });
    register("inputFirstName", { required: messageRequired });
    register("inputLastName", { required: messageRequired });
    // register("inputSchoolname",{ required: messageRequired });
    register("inputUniversity")
    register("inputYear")
    register("inputPmrProgram")
    register("inputPhoneNumber", { required: messageRequired });
    register("inputPassword", { 
      required: messageRequired,
      pattern: {
        // value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
          value : "^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$",
            message: "Minimum eight characters, at least one letter, one number and one special character."
        } ,
       
      });
    register("inputConfirmPassword", { required: messageRequired });

    register("inputEmail", { 
        required: messageRequired, 
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address."
        } 
    });  
  }, [])

  // Auto-select PM&R program and year when a valid group code is entered
  useEffect(() => {
    const data = props.validateGroupCode.data;
    if (data?.valid && data.programName) {
      const match = allPmrProgramOptions.find(o => o.value === data.programName);
      const option = match || { value: data.programName, label: data.programName };
      setSelectedProgram(option);
      setValue("inputPmrProgram", option.value);

      if (data.year) {
        const yearOption = yearOptions.find(o => o.value === data.year);
        if (yearOption) {
          setSelectedYear(yearOption);
          setValue("inputYear", yearOption.value);
        }
      }
    } else if (data && !data.valid) {
      // Invalid code — unlock but don't clear (user may have picked manually)
    }
  }, [props.validateGroupCode.data]);

  // Clear program lock when group code is emptied
  useEffect(() => {
    if (!groupCode.trim()) {
      // Only clear if it was auto-set from a group code
      if (props.validateGroupCode.data?.valid) {
        dispatch(validateGroupCodeReset());
      }
    }
  }, [groupCode]);

  const handleUniversityChange = (selectedOption) => {
    setValue("inputSchoolname", selectedOption.value)
    if(selectedOption.value != "Others"){
      setValue("inputUniversity", "")
    }
    setUniversity(selectedOption.value);
  };

  useEffect(() => {
    let universitiesList = schools.universities
    if(universitiesList){
      universitiesList = [...new Set(universitiesList.map((value, index) => {return {value:value, label: value}}))];
      setUniversities(universitiesList)
    }
  }, [schools])

  if(props.signupUser.loading){
    Swal.fire({
      allowOutsideClick : false,
      didOpen: () => {
        Swal.showLoading()

      }
    });

  }
  else{
    if(props.signupUser.signupuser.length && typeof props.signupUser.error === "undefined"){
      const hasPendingCode = sessionStorage.getItem('pendingGroupCode');
      const hasPendingIndividualCode = sessionStorage.getItem('pendingIndividualCode');
      const hasGroupCode = hasPendingCode || hasPendingIndividualCode;
      Swal.fire({
          title: `Welcome to ${specialtyName} Prep!`,
          text: hasGroupCode
            ? 'Your account has been created! Activating your group subscription...'
            : 'Your account has been created and your 14-day free trial is starting now!',
          icon : 'success',
          confirmButtonText: 'Get Started',
          confirmButtonColor: '#2dce89',
          allowOutsideClick: false,
        }
      ).then(function () {
        if (!hasGroupCode) {
          sessionStorage.setItem('postRegAction', 'startTrial');
        }
        dispatch(loginUser({email : getValues('inputEmail'), password : getValues('inputConfirmPassword')}));
      });
      dispatch(signupUserReset());
    }
    else if(typeof props.signupUser.error !== "undefined"){

      if(props.signupUser.error.hasOwnProperty('email')){
        Swal.fire({
          title:'Failed!',
          text:'Email is already in use!',
          icon :'error',
          timer: 3000

        })
      }
      else if(props.signupUser.error.hasOwnProperty('handle')){
        Swal.fire({
          title:'Failed!',
          text:'Username is already in use!',
          icon :'error',
          timer: 3000

        })
      }
      else if(props.signupUser.error.hasOwnProperty('general')){
        Swal.fire({
          title:'Failed!',
          text:'Something went wrong, Please try again!',
          icon :'error',
          timer: 3000

        })
      }
      else{
        Swal.fire({
          title:'Failed!',
          text:'Something went wrong, Please try again!',
          icon :'error',
          timer: 3000

        })
      }
      dispatch(signupUserReset());
    }

  }

  const formatDate = (date) => {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;

      return [year, month, day].join('-');
  }
  const onSubmit = (data) => {

    // Validate phone number
    const e164 = toE164(phoneNumber);
    if (!e164 || !isValidUSNumber(e164)) {
      Swal.fire({
        icon: 'error',
        title: "Invalid phone number",
        text: "Please enter a valid 10-digit U.S. phone number.",
      });
      return;
    }

    if(data.inputPassword == data.inputConfirmPassword){
      
      // data['name'] = data.inputFullname;
      // data['university'] = data.inputSchoolname;
      // data['email'] = data.inputEmail;
      // data['password'] = data.inputPassword;
      // data['confirmPassword'] = data.inputConfirmPassword;
      // data['handle'] = data.inputUsername;
      // data['tpcEntryDate'] = formatDate(new Date());
      // data['subscriptions'] = [];
      // data['tutorHours'] = 5;
      // data['phoneNumber'] = data.inputPhoneNumber;
      // data['admin'] = false;

        const formData = new FormData();
        formData.append('name', data.inputFirstName + " " +  data.inputLastName)
        formData.append('firstName', data.inputFirstName)
        formData.append('lastName', data.inputLastName)
        formData.append('addedUniversity', data.inputUniversity || '')
        formData.append('university', data.inputSchoolname || '')
        formData.append('email', data.inputEmail)
        formData.append('password', data.inputPassword)
        formData.append('confirmPassword', data.inputConfirmPassword)
        formData.append('handle', data.inputUsername)
        formData.append('tpcEntryDate', formatDate(new Date()))
        formData.append('subscriptions', [])
        formData.append('tutorHours', 5)
        formData.append('phoneNumber', phoneNumber)
        formData.append('year', selectedYear?.value || '')
        formData.append('pmrProgram', selectedProgram?.value || '')
        formData.append('heardAboutUs', heardAboutUs?.value === 'Other' ? (heardAboutUsOther.trim() || 'Other') : (heardAboutUs?.value || ''))
        formData.append('admin', false)
        formData.append('specialty', activeSpecialty)

      // Block submission if group code is entered but invalid
      if (groupCode.trim()) {
        if (props.validateGroupCode.loading) {
          Swal.fire({ icon: 'info', title: 'Validating code...', text: 'Please wait while we validate your group code.', timer: 2000, showConfirmButton: false });
          return;
        }
        if (!props.validateGroupCode.data?.valid) {
          Swal.fire({ icon: 'error', title: 'Invalid Group Code', text: props.validateGroupCode.data?.error || 'Please enter a valid group code or remove it to continue.' });
          return;
        }
        // For individual codes, pendingIndividualCode is already set in Step 3 onComplete.
        // For coordinator codes, use the normal pendingGroupCode flow.
        if (props.validateGroupCode.data?.paymentType !== 'individual') {
          sessionStorage.setItem('pendingGroupCode', groupCode.trim());
        }
      }

      // Append Stripe data from Step 3
      const sd = stripeDataRef.current;
      if (sd) {
        formData.append('stripeCustomerId', sd.customerId);
        formData.append('stripePaymentMethodId', sd.paymentMethodId);
        formData.append('selectedPlanId', sd.selectedPlanId);
        if (sd.bundleId) {
          formData.append('bundleId', sd.bundleId);
        }
      }

      dispatch(signupUser(formData));

    }
    else{
       setConfirmPasswordMatch(true);
    }
    // data.inputHandle = props.userDetails.handle;
    // data.handle = props.userDetails.handle;
    // data.userId = props.userDetails.userId;

    // if(mcatScoreId){
    //   data['docId'] = mcatScoreId;
    //   dispatch(updateMcatScore(data));
    // }
    // else{
    //   dispatch(createMcatScore(data));
    // }
    
  }

  const handleGoogleSignIn = async (e) => {
    e.preventDefault()
    const signIn = await signUpWithGoogle();
    // const { user, token } = await signInWithGoogle();
    // console.log('Google user:', user);
    // console.log('ID token:', token);

  };
  
  const handleFacebookSignIn = async (e) => {
    e.preventDefault()
    const signIn = await signUpWithFacebook();
    // const { user, token } = await signInWithGoogle();
    // console.log('Google user:', user);
    // console.log('ID token:', token);

  };

  
  const handleNext = () => {
    const values = getValues();
    const newErrors = {};

    if (!values.inputFirstName?.trim()) newErrors.inputFirstName = messageRequired;
    if (!values.inputLastName?.trim()) newErrors.inputLastName = messageRequired;
    if (!values.inputEmail?.trim()) {
      newErrors.inputEmail = messageRequired;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.inputEmail)) {
      newErrors.inputEmail = "Invalid email address.";
    }
    if (!values.inputPassword) {
      newErrors.inputPassword = messageRequired;
    } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(values.inputPassword)) {
      newErrors.inputPassword = "Minimum eight characters, at least one letter, one number and one special character.";
    }
    if (!values.inputConfirmPassword) {
      newErrors.inputConfirmPassword = messageRequired;
    } else if (values.inputPassword !== values.inputConfirmPassword) {
      newErrors.inputConfirmPassword = "Passwords do not match.";
    }

    setStep1Errors(newErrors);
    setConfirmPasswordMatch(false);

    if (Object.keys(newErrors).length === 0) {
      setStep(2);
    }
  };

  return (
    <>

        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent mb-2">
            <div className="text-muted text-center mt-2 mb-3">
              <span className="font-weight-bolder text-lg text-success">Create your Free Account</span>
            </div>

            {/* Specialty Switcher — hidden when bundle mode is active */}
            {!(step === 3 && isBundleMode) && <div className="d-flex justify-content-center mb-3">
              <Dropdown isOpen={specialtyDropdownOpen} toggle={() => setSpecialtyDropdownOpen(prev => !prev)}>
                <DropdownToggle
                  caret
                  color={getSpecialty(activeSpecialty).color}
                  className="d-flex align-items-center justify-content-between"
                  style={{ minWidth: '200px' }}
                >
                  <span>
                    <i className={getSpecialty(activeSpecialty).icon + " mr-2"} />
                    {specialtyName}
                  </span>
                </DropdownToggle>
                <DropdownMenu>
                  {SPECIALTY_IDS.map((id) => {
                    const spec = SPECIALTIES[id];
                    return (
                      <DropdownItem
                        key={id}
                        onClick={() => dispatch(switchSpecialty(id))}
                        active={id === activeSpecialty}
                        className="d-flex align-items-center"
                      >
                        <i className={spec.icon + " mr-2"} />
                        {spec.name}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
            </div>}

            {/* Progress Bar */}
            <div className="px-5 mb-1">
              <div style={{ height: 4, borderRadius: 2, background: '#e9ecef', overflow: 'hidden' }}>
                <div
                  style={{
                    height: '100%',
                    borderRadius: 2,
                    background: '#2dce89',
                    width: step === 1 ? '33%' : step === 2 ? '66%' : '100%',
                    transition: 'width 0.3s ease',
                  }}
                />
              </div>
            </div>
          </CardHeader>

          <CardBody className="px-lg-5 ">
            <div className="text-muted text-center mt-2 mb-4">
              <small>{step === 1 ? 'Enter your personal information' : step === 2 ? (activeSpecialty === 'pmr' ? 'Tell us about your program' : 'A few more details') : 'Choose your plan to get started'}</small>
            </div>
            <Form role="form" onSubmit={handleSubmit(onSubmit)}>
              {step === 1 && (<>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="First Name"
                    className="form-control-alternative"
                    id="inputFirstName"
                    name="inputFirstName"
                    
                    onChange={e => setValue("inputFirstName", e.target.value) }
                    type="text"
                  />
                  
                </InputGroup>
                { (errors.inputFirstName || step1Errors.inputFirstName) && <small className="text-danger">{errors.inputFirstName?.message || step1Errors.inputFirstName}</small> }
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-circle-08" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Last Name"
                    className="form-control-alternative"
                    id="inputLastName"
                    name="inputLastName"
                    
                    onChange={e => setValue("inputLastName", e.target.value) }
                    type="text"
                  />
                  
                </InputGroup>
                { (errors.inputLastName || step1Errors.inputLastName) && <small className="text-danger">{errors.inputLastName?.message || step1Errors.inputLastName}</small> }
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    className="form-control-alternative"
                    id="inputEmail"
                    name="inputEmail"
                    
                    onChange={e => {setValue("inputEmail", e.target.value); setValue("inputUsername", e.target.value)} }
                    type="email"
                  />
                  
                </InputGroup>
                { (errors.inputEmail || step1Errors.inputEmail) && <small className="text-danger">{errors.inputEmail?.message || step1Errors.inputEmail}</small> }
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    className="form-control-alternative"
                    id="inputPassword"
                    name="inputPassword"
                    onChange={e => setValue("inputPassword", e.target.value) }
                    type="password"
                  />
                </InputGroup>
                { (errors.inputPassword || step1Errors.inputPassword) && <small className="text-danger">{errors.inputPassword?.message || step1Errors.inputPassword}</small> }
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Confirm Password"
                    className="form-control-alternative"
                    id="inputConfirmPassword"
                    name="inputConfirmPassword"
                    onChange={e => setValue("inputConfirmPassword", e.target.value) }
                    type="password"
                  />
                </InputGroup>
                { (errors.inputConfirmPassword || step1Errors.inputConfirmPassword) && <small className="text-danger">{errors.inputConfirmPassword?.message || step1Errors.inputConfirmPassword}</small> }
                {confirmPasswordMatch && <small className="text-danger">Passwords do not match.</small> }
              </FormGroup>
              <div className="text-center">
                <Button className="mt-4" color="primary" type="button" onClick={handleNext}>
                  Continue <i className="fas fa-arrow-right ml-1" />
                </Button>
              </div>
              </>)}

              {step === 2 && (<>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-phone" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="(123) 456-7890"
                    className="form-control-alternative"
                    id="inputPhoneNumber"
                    name="inputPhoneNumber"
                    type="tel"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    inputMode="numeric"
                    autoComplete="tel"
                    maxLength={14}
                  />
                </InputGroup>
                { errors.inputPhoneNumber && <small className="text-danger">{errors.inputPhoneNumber.message}</small> }
              </FormGroup>

              {activeSpecialty === 'pmr' && (
              <>
              <FormGroup>
                <Select
                  placeholder="Select Year"
                  options={yearOptions}
                  styles={customDropdown}
                  id="inputYear"
                  name="inputYear"
                  onChange={(option) => {
                    setValue("inputYear", option?.value || '');
                    setSelectedYear(option);
                  }}
                  value={selectedYear}
                  isClearable={!(props.validateGroupCode.data?.valid && props.validateGroupCode.data?.year)}
                  isDisabled={!!(props.validateGroupCode.data?.valid && props.validateGroupCode.data?.year)}
                />
                {props.validateGroupCode.data?.valid && props.validateGroupCode.data?.year && (
                  <small className="text-muted">
                    <i className="fas fa-lock mr-1" />Set by group code
                  </small>
                )}
              </FormGroup>

              <FormGroup>
                <Select
                  placeholder={`Select ${specialtyName} Program`}
                  options={allPmrProgramOptions}
                  styles={customDropdown}
                  id="inputPmrProgram"
                  name="inputPmrProgram"
                  onChange={(option) => {
                    setValue("inputPmrProgram", option?.value || '');
                    setSelectedProgram(option);
                  }}
                  value={selectedProgram}
                  isClearable={!props.validateGroupCode.data?.valid}
                  isDisabled={!!props.validateGroupCode.data?.valid}
                />
                {props.validateGroupCode.data?.valid && (
                  <small className="text-muted">
                    <i className="fas fa-lock mr-1" />Set by group code
                  </small>
                )}
              </FormGroup>
              </>
              )}

              <FormGroup>
                <Select
                  placeholder="Where did you hear about us?"
                  options={heardAboutUsOptions}
                  styles={customDropdown}
                  id="inputHeardAboutUs"
                  name="inputHeardAboutUs"
                  onChange={(option) => {
                    setHeardAboutUs(option);
                    if (option?.value !== 'Other') setHeardAboutUsOther('');
                  }}
                  value={heardAboutUs}
                  isClearable
                />
              </FormGroup>
              {heardAboutUs?.value === 'Other' && (
                <FormGroup>
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-comment" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Please specify..."
                      className="form-control-alternative"
                      value={heardAboutUsOther}
                      onChange={(e) => setHeardAboutUsOther(e.target.value)}
                      type="text"
                    />
                  </InputGroup>
                </FormGroup>
              )}

              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-ticket-alt" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Group code (optional, e.g. GRP-ABC123)"
                    className="form-control-alternative"
                    value={groupCode}
                    onChange={handleGroupCodeChange}
                    type="text"
                    maxLength={10}
                  />
                  {groupCode.trim().length >= 6 && (
                    <InputGroupAddon addonType="append">
                      <InputGroupText style={{ background: 'transparent', border: 'none' }}>
                        {props.validateGroupCode.loading ? (
                          <i className="fas fa-spinner fa-spin text-muted" />
                        ) : props.validateGroupCode.data?.valid ? (
                          <i className="fas fa-check-circle text-success" />
                        ) : props.validateGroupCode.data && !props.validateGroupCode.data.valid ? (
                          <i className="fas fa-times-circle text-danger" />
                        ) : null}
                      </InputGroupText>
                    </InputGroupAddon>
                  )}
                </InputGroup>
                {props.validateGroupCode.data?.valid && (
                  <small className="text-success">
                    <i className="fas fa-check mr-1" />Valid code — {props.validateGroupCode.data.programName}
                  </small>
                )}
                {props.validateGroupCode.data && !props.validateGroupCode.data.valid && (
                  <small className="text-danger">
                    <i className="fas fa-times mr-1" />{props.validateGroupCode.data.error || 'Invalid code'}
                  </small>
                )}
                {(!groupCode || groupCode.trim().length < 6) && (
                  <small className="text-muted">Have a code from your residency program? Enter it here.</small>
                )}
              </FormGroup>

              <div className="text-center d-flex justify-content-center" style={{ gap: '12px' }}>
                <Button className="mt-4" color="secondary" type="button" onClick={() => setStep(1)}>
                  <i className="fas fa-arrow-left mr-1" /> Back
                </Button>
                {groupCode.trim() && props.validateGroupCode.data?.valid && props.validateGroupCode.data?.paymentType === 'individual' ? (
                  <Button className="mt-4" color="primary" type="button" onClick={() => {
                    const e164Check = toE164(phoneNumber);
                    if (!e164Check || !isValidUSNumber(e164Check)) {
                      Swal.fire({ icon: 'error', title: 'Invalid phone number', text: 'Please enter a valid 10-digit U.S. phone number.' });
                      return;
                    }
                    setStep(3);
                  }}>
                    Continue <i className="fas fa-arrow-right ml-1" />
                  </Button>
                ) : groupCode.trim() && props.validateGroupCode.data?.valid ? (
                  <Button className="mt-4" color="primary" type='submit'>
                    Create Account
                  </Button>
                ) : (
                  <Button className="mt-4" color="primary" type="button" onClick={() => {
                    // Validate phone number before proceeding
                    const e164Check = toE164(phoneNumber);
                    if (!e164Check || !isValidUSNumber(e164Check)) {
                      Swal.fire({ icon: 'error', title: 'Invalid phone number', text: 'Please enter a valid 10-digit U.S. phone number.' });
                      return;
                    }
                    setStep(3);
                  }}>
                    Continue <i className="fas fa-arrow-right ml-1" />
                  </Button>
                )}
              </div>
              </>)}

              {step === 3 && (() => {
                const vcData = props.validateGroupCode.data;
                const isIndividualCode = vcData?.valid && vcData?.paymentType === 'individual';

                if (isIndividualCode) {
                  return (
                    <Elements stripe={stripePromise} options={{ mode: 'payment', amount: Math.round(vcData.priceAmount * 100), currency: 'usd', payment_method_types: ['card', 'link'], setup_future_usage: 'off_session' }}>
                      <IndividualCodeRegistrationPayment
                        code={groupCode.trim()}
                        email={getValues('inputEmail')}
                        name={`${getValues('inputFirstName')} ${getValues('inputLastName')}`}
                        priceAmount={vcData.priceAmount}
                        planId={vcData.planId}
                        onBack={() => setStep(2)}
                        onComplete={(data) => {
                          // Store payment info for post-registration confirmation
                          sessionStorage.setItem('pendingIndividualCode', groupCode.trim());
                          sessionStorage.setItem('pendingIndividualPaymentIntentId', data.paymentIntentId);
                          stripeDataRef.current = {
                            customerId: data.customerId,
                            paymentMethodId: null,
                            selectedPlanId: data.selectedPlanId,
                          };
                          setStripeData(stripeDataRef.current);
                          handleSubmit(onSubmit)();
                        }}
                      />
                    </Elements>
                  );
                }

                return (
                  <Elements stripe={stripePromise} options={{ mode: 'setup', currency: 'usd', payment_method_types: ['card', 'link'] }}>
                    <RegistrationPaymentStep
                      email={getValues('inputEmail')}
                      specialty={activeSpecialty}
                      hasGroupCode={!!groupCode.trim()}
                      onPlanModeChange={(mode) => setIsBundleMode(mode === 'bundle')}
                      onBack={() => setStep(2)}
                      onComplete={(data) => {
                        stripeDataRef.current = data;
                        setStripeData(data);
                        handleSubmit(onSubmit)();
                      }}
                    />
                  </Elements>
                );
              })()}
            </Form>
          </CardBody>
        </Card>
      
    </>
  );
};

const mapStateToProps = state => {
  return {
    signupUser : state.signupUser,
    validateGroupCode : state.validateGroupCode,
  }
}

export default connect(mapStateToProps)(Register);
